import React, { forwardRef, memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { leftNav as i18nNamespace } from "../../../../../../../i18n/namespace";
import { selectFavouritesData } from "../../selectors/LeftNavSelectors";
import { CATEGORY_TYPES } from "../../constants/navigationConstants";
import Category from "../CategoryComponent";

const Favourites = memo(forwardRef(({ onCategoryMenuItemClicked, isOpen, open, selectedService, index, onKeyDown, className }, ref) => {
    const { favouritesList, servicesByKey } = useSelector(selectFavouritesData);
    const { t } = useTranslation(i18nNamespace);

    const category = useMemo(() => ({
        label: t(CATEGORY_TYPES.FAVORITES),
        services: favouritesList.map(favourite => servicesByKey[favourite])
    }), [favouritesList, servicesByKey, t]);

    if (favouritesList.length === 0) {
        return null;
    }
    
    return (
        <Category
            ref={ref}
            category={category}
            isOpen={isOpen}
            isActive={false}
            onCategoryMenuItemClicked={onCategoryMenuItemClicked}
            open={open}
            neverActive={true}
            selectedService={selectedService}
            index={index}
            onKeyDown={onKeyDown}
            className={className}
        />
    );
}));

Favourites.displayName = 'Favourites';

export default Favourites;
